import { render, staticRenderFns } from "./AccountTwoFaStepper.vue?vue&type=template&id=6b5147c4&scoped=true"
import script from "./AccountTwoFaStepper.vue?vue&type=script&lang=js"
export * from "./AccountTwoFaStepper.vue?vue&type=script&lang=js"
import style0 from "./AccountTwoFaStepper.vue?vue&type=style&index=0&id=6b5147c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5147c4",
  null
  
)

export default component.exports